import { initializeApp } from 'firebase/app';
import { getMessaging, Messaging } from 'firebase/messaging';

const firebaseConfig = {
	apiKey: "AIzaSyCIRdMw_FdywCgzPa491ULQVZkeU6Mq8K0",
	authDomain: "team-peps.firebaseapp.com",
	projectId: "team-peps",
	storageBucket: "team-peps.firebasestorage.app",
	messagingSenderId: "360847537153",
	appId: "1:360847537153:web:0a13ae1a6f036856c83c00"
};

export const app = initializeApp(firebaseConfig);

/**
 * `getMessaging()` touche `navigator`/`addEventListener` dès l'appel — absent
 * côté serveur (Node), ce qui plante tout rendu SSR au chargement du module.
 * `messaging` n'est consommé que par `PushNotificationService`, exclusivement
 * en réaction à une interaction utilisateur dans le navigateur : `undefined`
 * côté serveur ne casse rien puisqu'il n'y est jamais utilisé.
 */
export const messaging = typeof window !== 'undefined'
	? getMessaging(app)
	: (undefined as unknown as Messaging);
